import React from "react";

import { useQuery } from "@apollo/client/react/hooks/useQuery";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton, List, Paper, Stack, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { graphql } from "@/gql";
import { MealPatternNameKind, FoodSource } from "@/gql/graphql";
import { colors } from "@/theme/overrides/colors";
import { foodNameToMealPatternKind } from "@/utils/food";

import MealPatternItem from "./MealPatternItem";
import { PlannedFood, PlannedFoodPortion } from "./utils";


interface Props {
  className?: string;
  onClose: () => void;
  onAddMealPattern: (
    name: MealPatternNameKind,
    amountServings: number,
    food: PlannedFood,
    foodPortion: PlannedFoodPortion
  ) => void;
}

const useStyles = makeStyles()((theme) => ({
  root: {
    borderRadius: 0,
    padding: theme.spacing(4, 3),
  },
  title: {
    fontSize: 18,
    lineHeight: 1,
    fontWeight: 700,
    color: colors.dark,
  },
  closeButton: {
    padding: theme.spacing(1),
    color: colors.gray,
    backgroundColor: "#E8EEF6",
  },
  list: {
    maxHeight: "calc(100vh - 290px)",
    overflow: "auto",
  },
}));

const simpleFoodDatabaseQuery = graphql(`
  query SimpleFoodDatabase($sources: [FoodSource!]!) {
    foods(sources: $sources) {
      nodes {
        ...FoodItem
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`);

const MealPatternDatabase: React.FC<Props> = ({
  className,
  onClose,
  onAddMealPattern,
}) => {
  const { classes, cx } = useStyles();
  const { data } = useQuery(simpleFoodDatabaseQuery, {
    variables: { sources: FoodSource.Fel },
  });
  return (
    <Paper className={cx(classes.root, className)} elevation={0}>
      <Stack spacing={4}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography className={classes.title}>Select Items</Typography>
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Stack>
        <Stack>
          <List className={classes.list}>
            {data?.foods.nodes.map((food) => {
              const foodName = foodNameToMealPatternKind(food.name);
              return (
                <MealPatternItem
                  key={food.id}
                  name={foodName}
                  food={food}
                  foodPortion={food.portions[0]}
                  onAddMealPattern={onAddMealPattern}
                />
              );
            })}
          </List>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default MealPatternDatabase;
